import { useNavigate } from 'react-router-dom';

import { Button } from '@components/button';
import { ErrorScreen } from '@components/error-screen';
import { useScopedTranslate } from '@locale/translate';

export const AccessDenied = () => {
  const { t } = useScopedTranslate(locale);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <ErrorScreen code={403} heading={t('heading')} message={t('message')}>
      <Button variant="secondary" text={t('goBack')} onClick={handleGoBack} />
    </ErrorScreen>
  );
};

const locale = {
  en: {
    heading: 'Access Denied',
    message: "You don't have permission to access this page",
    goBack: 'Go back',
  },
};
